import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["primary", "isOpen", "onRequestClose", "children", "style", "shouldCloseOnEsc", "shouldCloseOnOverlayClick", "noPortal"];
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../@types/react-modal/react-modal.d.ts" />
import { Core } from "@faire/design-tokens";
import React, { useEffect } from "react";
import ReactModal from "react-modal";
import ModalPortal from "react-modal/lib/components/ModalPortal";
import { useTheme } from "styled-components";
import { getWindow } from "../../common/globals/getWindow";
import { initializeReactModal } from "./reactModal";
// ModalPortal is the content of the portal in the modal by default. It does
// not render a portal.
var SSRSafeModal = /*#__PURE__*/function (_ModalPortal) {
  function SSRSafeModal() {
    var _this;
    _classCallCheck(this, SSRSafeModal);
    _this = _callSuper(this, SSRSafeModal, arguments);
    _this.state = {
      isOpen: _this.props.isOpen,
      afterOpen: false,
      beforeClose: false
    };
    return _this;
  }
  _inherits(SSRSafeModal, _ModalPortal);
  return _createClass(SSRSafeModal);
}(ModalPortal);
export var BaseModal = function BaseModal(_ref) {
  var _theme$modals, _modalTheme$overlay, _style$overlay, _modalTheme$backgroun, _modalTheme$color, _style$content;
  var primary = _ref.primary,
    isOpen = _ref.isOpen,
    onRequestClose = _ref.onRequestClose,
    children = _ref.children,
    style = _ref.style,
    _ref$shouldCloseOnEsc = _ref.shouldCloseOnEsc,
    shouldCloseOnEsc = _ref$shouldCloseOnEsc === void 0 ? true : _ref$shouldCloseOnEsc,
    _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
    shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve,
    _ref$noPortal = _ref.noPortal,
    noPortal = _ref$noPortal === void 0 ? false : _ref$noPortal,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  useEffect(function () {
    if (isOpen && noPortal) {
      var _getWindow, _getWindow$document, _getWindow$document$g, _getWindow$document$g2;
      (_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow$document = _getWindow.document) === null || _getWindow$document === void 0 ? void 0 : (_getWindow$document$g = _getWindow$document.getElementById) === null || _getWindow$document$g === void 0 ? void 0 : (_getWindow$document$g2 = _getWindow$document$g.call(_getWindow$document, "main")) === null || _getWindow$document$g2 === void 0 ? void 0 : _getWindow$document$g2.setAttribute("aria-hidden", "true");
    }
    return function () {
      var _getWindow2, _getWindow2$document, _getWindow2$document$, _getWindow2$document$2;
      (_getWindow2 = getWindow()) === null || _getWindow2 === void 0 ? void 0 : (_getWindow2$document = _getWindow2.document) === null || _getWindow2$document === void 0 ? void 0 : (_getWindow2$document$ = _getWindow2$document.getElementById) === null || _getWindow2$document$ === void 0 ? void 0 : (_getWindow2$document$2 = _getWindow2$document$.call(_getWindow2$document, "main")) === null || _getWindow2$document$2 === void 0 ? void 0 : _getWindow2$document$2.removeAttribute("aria-hidden");
    };
  }, [isOpen, noPortal]);
  useEffect(function () {
    initializeReactModal();
  }, []);
  var modalTheme = (_theme$modals = theme.modals) === null || _theme$modals === void 0 ? void 0 : _theme$modals[primary ? "primary" : "default"];
  var ModalComponent = noPortal ? SSRSafeModal : ReactModal;
  var noPortalProps = noPortal ? {
    // Implement behaviour & defaults implemented in Modal (rather than the inner ModalPortal).
    ariaHideApp: true,
    shouldFocusAfterRender: true,
    bodyOpenClassName: "ReactModal__Body--open",
    role: "dialog",
    closeTimeoutMS: 0,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    overlayElement: function overlayElement(props, contentEl) {
      return /*#__PURE__*/React.createElement("div", _objectSpread({}, props), contentEl);
    },
    contentElement: function contentElement(props, children) {
      return /*#__PURE__*/React.createElement("div", _objectSpread({}, props), children);
    },
    // Provide a warning if we are accidentally hiding the modal because it is in "main"
    overlayRef: function overlayRef(_overlayRef) {
      if (_overlayRef) {
        var _getWindow$document$g3, _getWindow3, _getWindow3$document, _getWindow3$document$;
        var appElement = (_getWindow$document$g3 = (_getWindow3 = getWindow()) === null || _getWindow3 === void 0 ? void 0 : (_getWindow3$document = _getWindow3.document) === null || _getWindow3$document === void 0 ? void 0 : (_getWindow3$document$ = _getWindow3$document.getElementById) === null || _getWindow3$document$ === void 0 ? void 0 : _getWindow3$document$.call(_getWindow3$document, "main")) !== null && _getWindow$document$g3 !== void 0 ? _getWindow$document$g3 : undefined;
        if (appElement !== null && appElement !== void 0 && appElement.contains(_overlayRef)) {
          throw new Error('<Modal noPortal={true} /> must be rendered outside "main".');
        }
      }
    }
  } : {};
  return /*#__PURE__*/React.createElement(ModalComponent, _objectSpread(_objectSpread(_objectSpread({}, noPortalProps), otherProps), {}, {
    isOpen: isOpen,
    style: {
      overlay: _objectSpread({
        background: (_modalTheme$overlay = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.overlay) !== null && _modalTheme$overlay !== void 0 ? _modalTheme$overlay : "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000
      }, (_style$overlay = style === null || style === void 0 ? void 0 : style.overlay) !== null && _style$overlay !== void 0 ? _style$overlay : {}),
      content: _objectSpread({
        display: "flex",
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
        border: "none",
        borderRadius: "0",
        padding: "0",
        overflow: "auto",
        alignItems: "center",
        justifyContent: "center",
        WebkitOverflowScrolling: "unset",
        background: (_modalTheme$backgroun = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.background) !== null && _modalTheme$backgroun !== void 0 ? _modalTheme$backgroun : Core.surface.inverse,
        color: (_modalTheme$color = modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.color) !== null && _modalTheme$color !== void 0 ? _modalTheme$color : Core.text.default,
        outline: "none",
        position: "relative",
        boxShadow: modalTheme === null || modalTheme === void 0 ? void 0 : modalTheme.boxShadow
      }, (_style$content = style === null || style === void 0 ? void 0 : style.content) !== null && _style$content !== void 0 ? _style$content : {})
    },
    shouldCloseOnEsc: shouldCloseOnEsc,
    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
    onRequestClose: onRequestClose
  }), children);
};